import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function AttorneySFeeHearingsHero() {
  return <section data-section-id="259571" id="attorneys-fee-hearings-hero" className="relative flex min-h-[620px] items-center overflow-hidden bg-background py-28 text-foreground md:py-36 lg:py-44">
      <div className="absolute inset-0 z-0" aria-hidden="true">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_office_charcoal.png" alt="" className="h-full w-full object-cover object-center opacity-10" loading="lazy" />

        <div className="absolute inset-0 bg-gradient-to-b from-background/85 via-background/92 to-background" />
      </div>

      <div className="container relative z-10 mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="mx-auto max-w-5xl text-center">
          <p className="mb-6 font-default text-xs font-medium uppercase tracking-[0.24em] text-secondary">Attorney's Fee Hearings</p>

          <h1 className="font-default text-4xl font-bold leading-[0.98] tracking-tight text-primary md:text-6xl lg:text-7xl">
            Expert Witness in
            <br className="hidden md:block" />
            <span> Attorney&apos;s Fee Hearings</span>
          </h1>

          <p className="mx-auto mt-8 max-w-3xl font-default text-lg leading-relaxed text-muted-foreground md:text-xl">
            The question is not simply what was billed. The question is whether
            the fee requested is reasonable.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/ContactUsPage">
              <Button size="lg" className="h-12 w-full rounded-md bg-primary px-8 text-base text-primary-foreground shadow-md transition-colors hover:bg-primary/90 sm:w-auto">
                Inquire About Availability
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </Link>
          </div>

          <Separator className="mx-auto mt-12 max-w-2xl bg-border/50" />
        </div>
      </div>
    </section>;
}